import React from 'react';
import classnames from 'classnames';
import Tooltip from 'utils/components/tooltip';

import DropdownLink from '../../../../../../common/dropdown-link';

interface Props {
  currentSearchType: string;
  searchTypes: string[];
  className?: string;
  onChangeSearchType: (searchType: string) => void;
}

const SearchTypesDropdown: React.FC<Props> = ({
  searchTypes,
  className,
  currentSearchType,
  onChangeSearchType
}) => {
  const searchClassName = classnames('search-user-dropdown', className);

  // Map over the searchType and create valid dropdown item
  const dropdownItems: React.ReactElement[] = searchTypes.map((searchType: string) => (
    <span
      key={searchType}
      onClick={() => onChangeSearchType(searchType)}
      className={'search-item-type'}
    >
      {searchType}
    </span>
  ));

  return (
    <DropdownLink className={searchClassName} text={currentSearchType} items={dropdownItems} />
  );
};

export default SearchTypesDropdown;
